const $$splitComponentImporter = () => import('/app/src/routes/dashboard/supervisor/route.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/supervisor")({
  beforeLoad: async () => {
    const res = await fetch("/api/auth/get-session");
    if (!res.ok) throw redirect({
      to: "/login"
    });
    const session = await res.json();
    if (!session?.user) throw redirect({
      to: "/login"
    });
    if (session.user.role !== "supervisor") throw redirect({
      to: "/dashboard"
    });
    return {
      session
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});